import { MainEntryState } from './definitions';

import { mockLandingPageLabels } from '../../constants/main-entry-data';

export class MainEntryFactory
{
	public static build(): MainEntryState 
	{
		return { ...mockLandingPageLabels };
	}

	public static buildLanguageSelector() 
	{
		return {
			options: [
				{
					language: 'English',
					image: '/assets/usa.svg',
					abbr: 'ENG',
					value: 'en'
				},
				{
					language: 'Français',
					image: '/assets/canada.svg',
					abbr: 'FRA',
					value: 'fr'
				}
			]
		};
	}
}
